import { render, staticRenderFns } from "./Typegroup.vue?vue&type=template&id=e478d230&"
import script from "./Typegroup.vue?vue&type=script&lang=js&"
export * from "./Typegroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports